'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global services*/
(function ($) {
  var methods = {
    init: function (/*options*/) {
      /*var opts = $.extend({}, $.fn.widget_comments.defaults, options);*/

      return this.each(function () {
        var _this = this;
        var $this = $(this);

        if ($this.hasClass('widget-comments-new-init')) {
          return;
        }

        $this.addClass('widget-comments-new-init');
        $this.on('click', '.read', function (/*e*/) {
          methods.read.apply(_this, [$(this).closest('.comment')]);
          return false;
        });
      });
    },

    read: function read($comment) {
      var $btn = $comment.find('.read');

      blockElement($btn);
      $.get(services.get('router').path('comment_read', { id: $comment.data('activity_id') }), function (res) {
        unBlockElement($btn);
        if (res.msg === 'SUCCESS') {
          $comment.fadeOut();
        } else {
          services.get('notifications').viewErrorMessage();
        }
      });
    }
  };

  $.fn.widget_comments = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.widget_comments');
    }

  };

  $.fn.widget_comments.defaults = {};

})(jQuery);
